/*
 * @Author: your name
 * @Date: 2021-05-21 10:54:41
 * @LastEditTime: 2021-05-21 11:21:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\api\channel.js
 */
import request from '../../utils/request'
//渠道商列表
export function channellist(data) {
    return request({
        url: '/signing/eshop/srm/filterStore/getOrgFilterList',
        method: 'post',
        data
    })
}
//过滤标黑
export function filteringtheblack(data) {
    return request({
        url: '/signing/eshop/srm/filterStore/updateOrgFilterDetailEntity',
        method: 'post',
        data
    })
}
//查看操作记录
export function checkrecord(params) {
    return request({
        url: '/signing/eshop/srm/filterStore/queryOrgOperationRecordEntity',
        method: 'GET',
        params
    })
}
// 查看登陆人是否存在多系统
export function thequery(params) {
    return request({
        url: '/auth/account/queryOtherSystem',
        method: 'GET',
        params
    })
}
// 切换系统
export function changeSystem(params) {
    return request({
        url: '/auth/account/changeSystem',
        method: 'GET',
        params
    })
}


// WEBPACK FOOTER //
// ./src/SRM/api/channel.js